export default "__VITE_PUBLIC_ASSET__9b013a65__"